import {
  ActiveGoodRecommendationOptions,
  ActiveUncoachableReasons,
  ActiveInaccurateContactRecommendationReasons,
} from '@amzn/aet-contactrecommendation-kit';
import { IntlShape } from 'react-intl';

import {
  GoodRecommendationOptionsObject,
  UncoachableReasonsObject,
  InaccurateContactRecommendationReasonsObject,
} from '../../../api/CoachingNotes/schema';
import { getObjectOptions } from '../../CoachingForm/FieldComponents/Helpers';
import { Option } from '../../CoachingForm/FieldComponents/Select';

export const getAllGoodRecommendationOptions = (intl: IntlShape): Option[] => {
  const translations: Record<string, string> = {
    [GoodRecommendationOptionsObject.YES]: intl.formatMessage({
      id: 'cs_perfportal_yes',
      defaultMessage: 'Yes',
    }),
    [GoodRecommendationOptionsObject.NO]: intl.formatMessage({
      id: 'cs_perfportal_no',
      defaultMessage: 'No',
    }),
  };

  return getObjectOptions(GoodRecommendationOptionsObject, translations);
};

export const getGoodRecommendationOptions = (intl: IntlShape): Option[] => {
  return getAllGoodRecommendationOptions(intl).filter(
    goodRecommendation =>
      goodRecommendation.value in ActiveGoodRecommendationOptions
  );
};

export const getAllUncoachableReasonsOptions = (intl: IntlShape): Option[] => {
  const translations: Record<string, string> = {
    [UncoachableReasonsObject.BACKUP_SKILL]: intl.formatMessage({
      id: 'cs_perfportal_contact_recom_uncoachable_options_backup_skill',
      defaultMessage: 'Backup skill',
    }),
    [UncoachableReasonsObject.POLICY_PROCESS_ISSUE]: intl.formatMessage({
      id: 'cs_perfportal_contact_recom_uncoachable_options_policy_issue',
      defaultMessage: 'Policy or process issue',
    }),
    [UncoachableReasonsObject.NO_COACHABLE_BEHAVIORS]: intl.formatMessage({
      id: 'cs_perfportal_contact_recom_uncoachable_options_no_coachable_behaviors',
      defaultMessage: 'No coachable behaviors',
    }),
    [UncoachableReasonsObject.TECHNICAL_ISSUE]: intl.formatMessage({
      id: 'cs_perfportal_contact_recom_uncoachable_options_technical_issue',
      defaultMessage: 'Technical issue, contact not accessible',
    }),
    [UncoachableReasonsObject.CUSTOMER_DISCONNECT]: intl.formatMessage({
      id: 'cs_perfportal_contact_recom_uncoachable_options_customer_disconnect',
      defaultMessage: 'Customer disconnect',
    }),
    [UncoachableReasonsObject.MANAGER_DISCRETION]: intl.formatMessage({
      id: 'cs_perfportal_contact_recom_uncoachable_options_manager_discretion',
      defaultMessage: 'Coachable, but manager discretion',
    }),
    [UncoachableReasonsObject.OTHER]: intl.formatMessage({
      id: 'cs_perfportal_other',
      defaultMessage: 'Other',
    }),
  };

  return getObjectOptions(UncoachableReasonsObject, translations);
};

export const getAllInaccurateContactRecommendationReasonsOptions = (
  intl: IntlShape
): Option[] => {
  const translations: Record<string, string> = {
    [InaccurateContactRecommendationReasonsObject.INCORRECT_CATEGORY]:
      intl.formatMessage({
        id: 'cs_perfportal_contact_recom_uncoachable_options_incorrect_category',
        defaultMessage: 'Contact flagged in the category was not correct',
      }),
    [InaccurateContactRecommendationReasonsObject.NOT_WARRANT_COACHING]:
      intl.formatMessage({
        id: 'cs_perfportal_contact_recom_uncoachable_options_not_warrant_coaching',
        defaultMessage:
          'Contact flagged in the category was accurate, but did not warrant coaching',
      }),
    [InaccurateContactRecommendationReasonsObject.COACHING_DONE]:
      intl.formatMessage({
        id: 'cs_perfportal_contact_recom_uncoachable_options_correct_category_coaching_done',
        defaultMessage:
          'Contact flagged in the category was accurate and resulted in coaching',
      }),
    [InaccurateContactRecommendationReasonsObject.NO_BANDWIDTH_FOR_COACHING]:
      intl.formatMessage({
        id: 'cs_perfportal_contact_recom_uncoachable_options_correct_category_no_bandwidth_for_coaching',
        defaultMessage:
          'Contact flagged in the category was accurate but I did not have enough bandwidth to coach',
      }),
  };

  return getObjectOptions(
    InaccurateContactRecommendationReasonsObject,
    translations
  );
};

export const getUncoachableReasonsOptions = (intl: IntlShape): Option[] => {
  return getAllUncoachableReasonsOptions(intl).filter(
    uncoachableReason => uncoachableReason.value in ActiveUncoachableReasons
  );
};

export const getInaccurateContactRecommendationReasonsOptions = (
  intl: IntlShape
): Option[] => {
  return getAllInaccurateContactRecommendationReasonsOptions(intl).filter(
    inaccurateContactRecommendationReason =>
      inaccurateContactRecommendationReason.value in
      ActiveInaccurateContactRecommendationReasons
  );
};
